export const getSafeResourceUrl = (value) => {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value.trim())) return null;

  try {
    const url = new URL(value.trim());
    return ['http:', 'https:'].includes(url.protocol) && url.hostname ? url.href : null;
  } catch {
    return null;
  }
};
